import { Bell } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import { paths } from '@/config/paths';
import { useGetNotificationsInfinite } from '@/features/notifications/api/getNotifications';
import { Logo } from '../Logo/Logo';

export const APP_HEADER_HEIGHT_IN_PX = 76;

export const AppHeader = () => {
  const { t } = useTranslation('components', { keyPrefix: 'appLayout.navigation' });

  const { data } = useGetNotificationsInfinite({ limit: 20 });
  const hasUnreadNotifications = (data?.pages[0]?.unreadCount ?? 0) > 0;

  return (
    <header
      className='bg-fill-background-neutral fixed top-[var(--system-banner-height,0px)] left-0 z-50 flex w-full justify-between px-5 py-4'
      style={{
        height: `${APP_HEADER_HEIGHT_IN_PX}px`,
      }}
    >
      <Logo variant='link' />
      <Link to={paths.notifications.home.getHref()} className='flex size-11 items-center justify-center' aria-label={t('notifications')}>
        <div className='relative'>
          {hasUnreadNotifications && (
            <>
              <div
                className={'bg-text-brand-primary outline-fill-background-neutral absolute -top-0.5 right-0 size-2 rounded-full outline-2'}
                data-testid='unread-indicator'
              />
              <span className='sr-only'>{t('unreadAriaLabel')}</span>
            </>
          )}
          <Bell className='text-text-default-secondary size-6' aria-hidden />
        </div>
      </Link>
    </header>
  );
};
